// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_cHH","cls2":"PaperClaiming-cls2_K_2 PaperClaiming-cls1_cHH","selected":"PaperClaiming-selected_xwU"};